// extracted by mini-css-extract-plugin
export var quantityInput = "_fo-0";